import React from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { fadeUp, staggerContainer, viewportOnce } from "@/lib/motion";

const CARDS = [
  {
    quote:
      "Abbiamo dato un primo sguardo al report e i risultati di giugno sono più che ottimi: le percentuali rispetto all'anno precedente sono più che raddoppiate. Non avevamo dubbi sulle tue capacità e sul fatto che avresti dato la migliore impostazione possibile alla nostra attività. Sei davvero unico in questo — e siamo certi che ci toglieremo altre soddisfazioni importanti.",
    descriptor: "Michele ed Eliana · Residence a Marina di Pescoluse",
  },
  {
    quote:
      "Non sapevo davvero da dove partire e avevo avuto solo esperienze negative con altre agenzie e gestori. Ho scelto di affidarmi ad Alessandro per imparare a gestire la mia struttura al meglio: finalmente ho trovato una persona di cui fidarmi.",
    descriptor: "Rocco · Camera e casa vacanze a Tricase",
  },
];

export const Testimonianze = () => (
  <section id="testimonianze" data-testid="section-testimonianze" className="bg-cream py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <motion.div variants={staggerContainer} initial="hidden" whileInView="show" viewport={viewportOnce} className="max-w-3xl">
        <motion.p variants={fadeUp} className="mb-5 text-xs font-semibold uppercase tracking-[0.25em] text-gold">
          Dicono di noi
        </motion.p>
        <motion.h2 variants={fadeUp} className="font-display text-4xl font-medium tracking-tight text-navy sm:text-5xl">
          Le parole di chi ci ha scelto.
        </motion.h2>
      </motion.div>

      <motion.div
        variants={staggerContainer}
        initial="hidden"
        whileInView="show"
        viewport={viewportOnce}
        className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-8"
      >
        {CARDS.map((c, i) => (
          <motion.figure
            key={i}
            variants={fadeUp}
            data-testid={`testimonial-${i}`}
            className="relative flex flex-col rounded-2xl border border-navy/10 bg-white p-8 shadow-[0_8px_30px_rgba(31,58,95,0.05)] md:p-10"
          >
            <Quote className="h-8 w-8 text-gold/40" />
            <blockquote className="mt-5 flex-1 text-lg italic leading-relaxed text-navy-deep">
              «{c.quote}»
            </blockquote>
            <figcaption className="mt-8 border-t border-navy/10 pt-5 text-sm font-medium text-navy">
              {c.descriptor}
            </figcaption>
          </motion.figure>
        ))}
      </motion.div>
    </div>
  </section>
);
